<template>
    <div class="artist_item">
      <router-link :to="'/artist/' + item.id">
        <div class="inner">
        <div class="pic" :style="'background-image:url(' + item.pic_tumb_big + ')'"></div>
        <div class="texts">
            <h3 v-text="item.name"></h3>
            <h4>לינקיפדיה</h4>
        </div>
        </div>
        </router-link>
    </div>

</template>

<script>
  
export default {
  props: ["item"],
  data(){
    return {
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

.artist_item {
  .inner { background: #fff; border-radius: 33px; position: relative; -moz-transition:all 0.2s ease 0s;-o-transition:all 0.2s ease 0s;-webkit-transition:all 0.12s ease 0s;transition:all 0.2s ease 0s; }
  .pic { border-radius: 33px; padding-bottom: 100%; background: center center no-repeat; background-size: cover; 
      &::after { content: ""; display: block; position: absolute; left: 0px; top: 0px; width:100%; height: 100%;  border-radius: 33px; overflow: hidden;
          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.23);
          background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.7));
      }
  }
  .texts { 
      &{ position: absolute; bottom: 0px; right: 0px; left: 0px; padding:15px 15px; color: #fff; }
      h3 { font-size: 25px; font-weight: 500; margin-bottom: 4px; }
      h4 { font-size: 20px; font-weight: 200; }
      .date { font-size: 16px; font-weight: 200; opacity: 0.6; }
  }
}
</style>